import { call, put, takeLatest } from "redux-saga/effects";
import { apiWrapper } from "../../../api/apiWrapper";
import { IBaseResponeModel } from "../../../models/response/base-response";
import { actions } from "../../actions/actionsWrapper";
import { eHocSinhViewShortActionTypeIds, IHocSinhViewShortActionTypes } from "../../action-types/thuc-don/IHocSinhViewShortActionTypes";

export function* hocSinhViewShortSaga(): any {
    yield takeLatest(eHocSinhViewShortActionTypeIds.LOAD_START, loadWorker)
}

function* loadWorker(action: IHocSinhViewShortActionTypes): any {
    try {
        const payload = action.payload;
        const res: IBaseResponeModel = yield call(apiWrapper.hocSinh.SelectViewShort as any, payload);

        if (res.is_success) {
            yield put(actions.thucDonWrapper.hocSinhViewShort.LOAD_SUCCESS(res.data))
        } else {
            yield put(actions.thucDonWrapper.hocSinhViewShort.LOAD_ERROR(res.message ?? "Error"))
        }
    } catch (error: any) {
        yield put(actions.thucDonWrapper.hocSinhViewShort.LOAD_ERROR(error.message ?? "Unexpected error occurred"))
    }
}
